import { oc } from '@orpc/contract';
import { listCostItemsOutputSchema, updateCostItemInputSchema } from '../schemas/costs.schemas.js';
/**
 * PATCH semantics with the status rules of plan §5.5: `IN_PROGRESS` needs a remaining estimate (the
 * service defaults it to `max(0, estimate − actual)`), `DONE` needs an actual, and `WAIVED` is reached
 * only through `costs.waive`.
 */
export const updateCostItemContract = oc
    .route({
    method: 'PATCH',
    path: '/costs/{id}',
    tags: ['Costs'],
    summary: 'Update a cost item’s amounts, status or supplier',
})
    .input(updateCostItemInputSchema)
    .output(listCostItemsOutputSchema);
//# sourceMappingURL=update-cost-item.contract.js.map